import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
    const userIP = localStorage.getItem("User-IP");
    const reCAPTCHA = localStorage.getItem("reCAPTCHA");
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };
    if (userIP && request.url !== `${environment.apiExternalIPapi}/json`) {
      headersConfig['User-IP'] = userIP;
    }
    if (reCAPTCHA && request.url.includes(environment.apiLogin)) {
      headersConfig['reCAPTCHA'] = reCAPTCHA;
    }
    if (
      session &&
      session.user &&
      session.user.token_type &&
      session.user.access_token
    ) {
      headersConfig['Authorization'] =
        session.user.token_type + ' ' + session.user.access_token;

        // session.user.token_type + ' ' + 'eyJhbGciOiJIUzI1NiJ9.`eyJjb21wYW55Q29kZSI6Ik9FIiwic3ViIjoiT0VBRE1JTiIsIm5iZiI6MTY0MDIwNjM4OCwiZW50aXR5Q29kZSI6MTExLCJ1YmlnZW9Db2RlIjoiMTUwMTMwIiwicGVybWlzc2lvbnMiOlsiTklWRUxfMyIsIlBSRUNJTyIsIlNUT0NLIiwiRkxFVEUiLCJDUkVESVRPIiwiVUVNUFJFU0EiLCJVQ0xJRU5URSIsIlJFSU1QUkVTSU9OIiwiTURFU1BBQ0hPIiwiQU5VTEFDSU9OIl0sInJvbGVzIjpbIkFETUlOSVNUUkFET1IiLCJKRUZFIERFIFNFQ0NJT04iXSwiaXNzIjoibWljcm9uYXV0IiwiZXhwIjoyMzc2OTYyMTAwLCJpYXQiOjE2NDAyMDYzODgsInVzZXJJZCI6M30.X_XHFGxfY3-KFhvF_85zeUplGD3RWxNeDbsYkX9TJvc';
    }
    request = request.clone({ setHeaders: headersConfig });
    return next.handle(request);
  }
}
